<script>
    import {mapState} from 'vuex';

    export default {
        name: "InactivityWatcher",
        created () {
            if (typeof this.inactivitySettings !== 'undefined') {
                this.checkIdleness();
            }
        },
        computed: {
            ...mapState('user',[
                'inactivitySettings'
            ])
        },
        methods: {
            checkIdleness (inactiveTime, timeToAbort, messageDescription,messageTitle) {
                let movedMouse = false;
                let pressedKey = false;

                if (typeof inactiveTime === "undefined") {
                    inactiveTime = this.inactivitySettings.inactiveTime;
                    inactiveTime = inactiveTime * 1000 * 60; // change ms to secs
                }

                if (typeof timeToAbort === "undefined") {
                    timeToAbort = this.inactivitySettings.timeToAbort; // seconds
                }

                if (typeof messageDescription === "undefined") {
                    messageDescription =  this.inactivitySettings.messageDescription;
                }
                if (typeof messageTitle === "undefined" && typeof this.inactivitySettings.messageTitle !== "undefined") {
                    messageTitle =  this.inactivitySettings.messageTitle;
                } else {
                    messageTitle = "Inactivity";
                }

                let idleInterval = window.setInterval( () => {
                    if (!movedMouse && !pressedKey) {
                        let buttonMessage = this.inactivitySettings && this.inactivitySettings.buttonMessage ?
                                            "Timer_" + timeToAbort + "_" + this.inactivitySettings.buttonMessage :
                                            "Timer_" + timeToAbort ;

                        showMessage("alert", messageTitle, messageDescription, [{"name": buttonMessage}]);
                        window.clearInterval(idleInterval);
                    }
                }, inactiveTime);

                $('body').off("mousemove.noIdle").on("mousemove.noIdle",  () => {
                    movedMouse = true;
                    window.clearInterval(idleInterval);
                    this.checkIdleness();
                });

                $(document).off("keypress.noIdle").on("keypress.noIdle", () => {
                    pressedKey = true;
                    window.clearInterval(idleInterval);
                    this.checkIdleness();
                });
            }
        }
    }
</script>

